var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2008 10.8828H19.8008C18.7008 10.8828 17.6008 11.4828 17.1008 12.4828L8.80078 27.3828C8.30078 28.2828 8.30078 29.4828 8.80078 30.3828L17.1008 45.2828C17.6008 46.2828 18.7008 46.8828 19.8008 46.8828H36.2008C37.3008 46.8828 38.4008 46.2828 38.9008 45.2828L47.2008 30.3828C47.7008 29.4828 47.7008 28.2828 47.2008 27.3828L38.9008 12.4828C38.4008 11.4828 37.3008 10.8828 36.2008 10.8828Z",
    fill: "#3E3E8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8004 35.0828L42.7004 26.2828C43.2004 25.3828 43.2004 24.2828 42.7004 23.3828L34.6004 8.88281C34.1004 7.88281 33.1004 7.38281 32.0004 7.38281H16.0004C14.9004 7.38281 13.9004 7.98281 13.4004 8.88281L10.4004 14.2828",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00039 20.4844L5.40039 23.3844C4.90039 24.2844 4.90039 25.3844 5.40039 26.2844L13.4004 40.8844C13.9004 41.8844 14.9004 42.3844 16.0004 42.3844H32.0004C33.1004 42.3844 34.1004 41.7844 34.6004 40.8844L35.2004 39.7844",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 25.3828L21.5 30.3828L31.5 20.3828",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModal);
export default __webpack_public_path__ + "static/media/modal.f945c925.svg";
export { ForwardRef as ReactComponent };